<template>
  <div class="home" style="position: relative;">
    <img alt="" class="banner" src="../assets/imgs/home-banner.png" />
    <div class="wrap">
      <div class="hack">
        <div>
          <img alt="" src="../assets/imgs/home-hack-person.svg" />
          <div>
            <p>
              <span>
                <count-to :endVal="53258" :startVal="0" />
              </span>
              人次
            </p>
            <p>累计测评人次</p>
          </div>
        </div>
        <p class="divider"></p>
        <div>
          <img alt="" src="../assets/imgs/home-hack-city.svg" />
          <div>
            <p>
              <span>
                <count-to :endVal="239" :startVal="0" />
              </span>
              个
            </p>
            <p>服务中国城市</p>
          </div>
        </div>
        <p class="divider"></p>
        <div>
          <img alt="" src="../assets/imgs/home-hack-store.svg" />
          <div>
            <p>
              <span>
                <count-to :endVal="867368" :startVal="0" />
              </span>
              家
            </p>
            <p>正在使用商户</p>
          </div>
        </div>
        <p class="divider"></p>
        <div>
          <img alt="" src="../assets/imgs/home-hack-count.svg" />
          <div>
            <p>
              <span>
                <count-to :endVal="121368" :startVal="0" />
              </span>
              次
            </p>
            <p>门诊服务人次</p>
          </div>
        </div>
      </div>
      <div class="description">
        <div class="description-logo">
          <div class="bg-theme"></div>
          <img alt="" src="../../public/logo.png" />
          <div class="bg-theme"></div>
        </div>
        <div class="description-content">
          <p>辰微沐阳</p>
          <p>立足于心理健康领域</p>
          <p>是一家 <span>智慧心理服务</span> 公司</p>
          <p>
            致力打造
            <span>"效字化+智慧社会心理服务体系"</span> 闭环式服务模式为基础
          </p>
          <p>以 <span>"按需定制"</span> 为核心竞争力</p>
          <p>以服务为基础,以技术为导向，以运维为根本，以智慧化为发展</p>
          <p>立足于 <span>智慧化生态体系</span> 云平台</p>
          <p>全力打造</p>
          <p>
            <span
              >医院心身诊疗中心、康养中心整体建设、校园心理服务体系建设、少儿中心、</span
            >
          </p>
          <p><span>社会心理服务体系建设、睡眠诊疗中心、连锁心理诊所</span></p>
          <p>七大板块</p>
        </div>
      </div>

      <p class="mobile pub-img-title">
        <img class="" src="../assets/mobile-imgs/second-title.png" />
      </p>
      <p class="pc pub-img-title">
        <img src="../assets/mobile-imgs/second-title.png" />
      </p>

      <div
        v-for="(item, index) in second"
        :key="index"
        :class="{ even: index !== 0 && index % 2 !== 0 }"
        class="second"
      >
        <div class="second-box">
          <img :src="item.img" alt="" />
          <div>
            <p
              :style="{ color: index == 2 ? 'red' : '' }"
              class="second-sub"
              style="text-indent: 38px"
            >
              {{ item.sub }}
            </p>
            <p class="second-content" style="text-indent: 25px">
              {{ item.content }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <p class="mobile pub-img-title">
        <img class="" src="../assets/mobile-imgs/bottom-title.png" />
      </p>
      <p class="public-title pc" content="WHYTHECHOOSE">为什么选择辰微沐阳</p>
      <div class="wrap">
        <div v-for="(item, index) in bottom" :key="index" class="bottom-box">
          <div class="bottom-img-box"></div>
          <p class="name">{{ item.name }}</p>
          <div class="hr"></div>
          <p class="desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <div class="consultation">
      <div class="consul" @click="DialogVisible" style="z-index: 999;">
        <img src="../assets/imgs/consultation.svg" alt="" width="30px" />
        <p style="margin-top: 5px;color: #86c2d3;">在线咨询</p>
      </div>
      <div class="consul" style="margin-top: 60px;"></div>
      <div class="consul" style="position: relative;">
        <!-- <iframe src="https://rc.xinli121.com/" frameborder="0" width="1800px" height="700px"
          style=" position: absolute;right: -85px;bottom: -200px;"></iframe> -->
      </div>
    </div>
    <div class="customer" v-if="centerDialogVisible">
      <div class="closeDialog" @click="centerDialogVisible = false">
        <el-icon class="el-icon-circle-close"></el-icon>
      </div>
      <p class="info-title">
        辰微官网
      </p>
      <div class="userlist-right">
        <div class="chat">
          <div ref="scrollbarRef" class="scrollbar" id="scrollbar">
            <div class="chat-list">
              <span
                style="text-align: center;font-size: 12px;margin-top: 10px;"
              >
                {{ timeDate }}
              </span>
              <!-- chat-list-left -->
              <div
                :class="[
                  item.position == 'left'
                    ? 'chat-list-left'
                    : 'chat-list-right',
                ]"
                v-for="(item, index) in messages.content"
                :key="index"
              >
                <img
                  v-if="item.position == 'left'"
                  src="../assets/imgs/logo.png"
                  class="list-img"
                />
                <img
                  v-else
                  src="../assets/imgs/service-section-2-2.png"
                  class="list-img"
                />
                <div
                  :class="[item.position == 'left' ? 'left-msg' : 'right-msg']"
                >
                  {{ item.content }}
                </div>
              </div>
            </div>
          </div>
          <div class="chat-boom">
            <el-input
              class="textarea"
              type="textarea"
              :rows="7"
              placeholder="请输入您想咨询的问题"
              v-model="text"
              @keyup.enter.native="send"
              maxlength="200"
              show-word-limit
              resize="none"
            />
          </div>
          <!-- <div style="background-color: #fff; display: flex; justify-content: end"> -->
          <el-button class="button" @click="send" size="mini">发送</el-button>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "Home",
  components: {},
  data() {
    return {
      userId: "",
      servePath: "ws://localhost:3000",
      ws: null,
      thirdText: ["平台建设", "硬件", "软件", "开发", "服务", "培训"],
      bottom: [
        {
          name: "新技术",
          desc:
            "根据客户需求定制资源配置，可实现链接5G时代的智能物联网，扩展心理设备链接",
        },
        {
          name: "新产品",
          desc: "行业内较先融合多维度心理数据倾力打造共享开放的心理健康融平台",
        },
        {
          name: "新模式",
          desc: "服务模式实现由单纯提供心理设备向提供多样化可定制服务的转变",
        },
        {
          name: "新服务",
          desc:
            "辰微沐阳心理品牌始创于2019年，专注于心理健康的区域化落地应用，具有雄厚的心理领域专业技术实力。",
        },
      ],
      second: [
        {
          sub:
            '打造 "互联网+智慧校园心理胆务体系建设" 闭环式服务摸式强化校园安全体系，创建学校教育优势，护航区域未成年人身心健康，优质成长！',
          content:
            "服务案例:攀枝花市全市校园心理服务、西昌市全市校园心理服务、南充市高坪区心理服务、德阳市经开区全区校园心理服务、广元市朝天区较园心理股务、西南科技大学、电子科大、成都石室天府中学、成都第57中学、成都沙河源小学、洛带中学、彭山区软马学校、遂宁第七中学、巴中通江泥溪中学、北川职中、越四中学、越四第二中学、西城中学、文吕中学",
          img: require("../assets/imgs/home-second-1.jpg"),
        },
        {
          sub:
            "打造“互联网+智慧医疗心身医学科体系建设”闭环式服务模式，以心理智慧体系系统&大数据中心为平台，以全区域覆盖为优势，助力心身医学科快速发展!",
          content:
            "服务案例:华西心理健康促进中心、北京直武医院、遵义医院附属医院四川省肿瘤医院，西昌市人民总医院，西昌市第二人民医院，自贡荣县精神病院，广元市朝天区人民医院。成都东慈医院。成都市青白江人民医院。",
          img: require("../assets/imgs/home-second-2.jpg"),
        },
        {
          sub:
            '打造“互联网+党政干部心理健康服务体系建设" 闭环式服务模式，以社会心理服务体系建设理念为设计纲耍,以智慧心理健康服务系统&大数据中心为平台，以专业心理服务队伍为基础。多堆度关心关爱干部心理健康!',
          img: require("../assets/imgs/home-second-3.jpg"),
        },
        {
          sub:
            '“智慧矫正柔性治理心效融合全面帮扶”构建“评估.预警．疏导、干预、服务、教育"六位一体的智慧社矫多种服务体系',
          content:
            "服务案例:成都市郫都区司法局、广元朝天区司法局、绵阳北川司法局、乐山五通桥司法局、宜宾南溪区司法局、自贡贡井区司法局",
          img: require("../assets/imgs/home-second-4.jpg"),
        },
        {
          sub:
            "打造“数字化+企业心理健康服务体系建设“闭环式服务模式，以社会心理服务体系建设理念为设计纲要，以智慧心理健康服务系统&大数据中心为平台，以专业心理服务队伍为基础，多维度关心员工心理健康，使员工成为更好的自己，更好的将自身价值与企业价值相结合!",
          img: require("../assets/imgs/home-second-5.jpg"),
          content:
            "服务案例:10所EAP定制服务、社区网格是EAP服务体系，中铁八局二公司EAP定制服务，成都市高新区社区发展治理和社会保障局EAP定制服务、重庆市两江新区EAP定制服务，中铁国际面向员工EAP服务体系，马士基信息处理公司EAP定制服务、西南财经大学EAP定制服务、心心谨机构定制服务、东洪社区定制服务\n",
        },
        {
          sub:
            '秉承现代“生物-心理-社会医学"模式、融合“医教结合”的新型诊疗理念，特色诊疗群体为青少年群体及附属的家庭单元，涵盖精神科诊疗、心理咨询及治疗，家庭教育、心理评估、社会心理综合服务等五大服务板块。',
          img: require("../assets/imgs/home-second-6.jpg"),
          content:
            "擅长处理:情堵困扰，人际关系，家庭困扰，青少年成长。亲子教育、职场问题、婚烟恋爱、其它心理健康问题\n咨询方式:成人个体咨询，少儿个体咨询，婚烟/伴侣咨询，家庭咨询，团体咨询",
        },
      ],
      centerDialogVisible: false,
      messages: null,
      timeDate: null,
      text: null,
    };
  },
  created() {
    // 先判断是否存在id
    const userId = localStorage.getItem("userId");
    this.userId = userId || this.getUserId();
  },
  // 页面离开了 断开链接
  destroyed() {
    this.ws.close();
  },
  mounted() {
    this.getMessage();
    this.scrollToBottom();
    // this.init();
  },
  methods: {
    //用户进页面生成随机ID
    getUserId() {
      let existingIds = new Set(); // 使用Set提高查找效率

      /**
       * 生成一个唯一的6位数随机ID
       * @returns {number} 唯一的6位随机ID
       */
      function generateUniqueSixDigitId() {
        while (true) {
          // 生成一个6位的随机数，范围从100000到999999
          let randomId =
            Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000;

          // 检查生成的ID是否已存在
          if (!existingIds.has(randomId)) {
            // 如果不存在，则添加到集合中并返回
            existingIds.add(randomId);
            return randomId;
          }
        }
      }
      const userId = String(generateUniqueSixDigitId());
      // 模拟用户进入页面时调用此函数
      localStorage.setItem("userId", userId);
      return userId;
    },
    init() {
      const env = process.env.NODE_ENV === "development" ? "dev" : "prod";
      const domain = {
        dev: "ws://192.168.3.35:11401/user/",
        prod: "wss://api.xinli121.com/user/",
      };
      this.ws = new WebSocket(`${domain[env]}${this.userId}`);
      //当客户端收到服务端发来的消息时，触发onmessage事件

      this.ws.onopen = (e) => {
        console.log("连接成功");
      };
      // 如果收到消息会触发这个函数
      this.ws.onmessage = (e) => {
        //e.data 的数据格式也是字符串，手动解析这些数据才能得到其他格式的数据。
        console.log("收到的消息", e);
        this.messages.content.push({
          content: e.data,
          position: "left",
        });
        // 收到聊天以后滚动到底部
        this.scrollToBottom();
      };
      //当客户端收到服务端发送的关闭连接请求时，触发onclose事件
      this.ws.onclose = function(e) {
        console.log("关闭链接了", e);
        this.$message({
          message: "链接断开，正在重新链接！",
          type: "warning",
        });
        this.ws = null;
        this.init();
      };

      //如果出现连接、处理、接收、发送数据失败的时候触发onerror事件
      this.ws.onerror = function(e) {
        console.log("err", e);
      };
    },
    getMessage() {
      (this.messages = {
        content: [
          {
            content: "您好，欢迎来到辰微官网，您需要咨询什么问题？",
            position: "left",
          },
        ],
        time: new Date().toLocaleDateString("zh-CN", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }),
        position: "left",
      }),
        this.scrollToBottom();
    },
    async send(e) {
      e.preventDefault();
      if (!this.ws) return this.$message.error("已断开");
      if (this.text.trim() === "" || this.text == "") {
        this.$message("不能发送空白的消息");
      } else {
        // 消息发送了要往聊天记录里面放进去 要放到当前聊天哪个用户的内容里面去  index是当前聊天哪个用户的下标
        console.log(this.messages.content, "ccc");
        this.messages.content.push({
          content: this.text,
          position: "right",
        });
        // 发送聊天以后滚动到底部
        this.scrollToBottom();

        this.ws.send(
          JSON.stringify({
            userId: this.userId,
            content: this.text,
            type: 0,
          })
        );
        // 清空输入框的内容
        this.text = "";
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const list = this.$el.querySelector(".chat-list");
        if (list) {
          list.scrollTop = list.scrollHeight;
        }
      });
    },
    getInfoData() {
      this.timeDate = new Date().toLocaleDateString("zh-CN", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },
    DialogVisible() {
      this.centerDialogVisible = true;
      this.init();
      this.getInfoData();
    },
  },
};
</script>
<style lang="less" scoped>
.banner {
  width: 100%;
}

.hack {
  margin: 23px 0 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 33px 44px;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  & > div {
    display: flex;
    align-items: center;

    img {
      width: 56px;
      margin-right: 24px;
    }

    p {
      font-size: 10px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #575757;

      span {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #42aab2;
      }
    }

    p:last-child {
      margin-top: 8px;
      color: #9f9f9f;
    }
  }

  .divider {
    width: 1px;
    height: 35px;
    background: #42aab2;
  }
}

.second {
  width: 100%;
  margin-bottom: 44px;

  &.even {
    .second-box {
      flex-direction: row-reverse;
    }
  }

  &-title {
    font-size: 26px;
    font-weight: bolder;
    color: #42aab2;
    margin: 40px 0;

    img {
      vertical-align: middle;
    }
  }

  &-box {
    display: flex;
    flex: 1;
    align-items: center;

    img {
      width: 700px;
      margin-right: 28px;
    }

    div {
      width: calc(100% - 728px);

      p:first-child {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #42aab2;
        margin-bottom: 40px;
      }

      p:last-child {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666565;
        line-height: 30px;
        white-space: pre-wrap;
      }
    }
  }
}

.third {
  & > p {
    margin-bottom: 32px;
    text-align: center;
  }

  & > div {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    & > div {
      width: 350px;
      height: 188px;
      position: relative;
      margin-bottom: 50px;
      background-image: url("../assets/imgs/home-third-bg.jpg");
      background-size: cover;
      background-repeat: no-repeat;
      overflow: hidden;
      border-radius: 5px;
      cursor: pointer;

      .mask {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 100%;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.15s linear;

        span {
          display: inline-block;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
          position: relative;
          // letter-spacing: 2px;
        }

        span::after {
          width: 32px;
          height: 3px;
          background: #ffffff;
          transform: translateX(-50%);
          position: absolute;
          left: 50%;
          bottom: -7px;
          content: "";
        }
      }
    }

    & > div:hover {
      .mask {
        bottom: 0;
      }
    }
  }
}

.bottom {
  width: 100%;
  height: 500px;
  background: url("../assets/imgs/home-bottom-bg.png") no-repeat;
  background-size: cover;
  margin-bottom: 50px;
  padding-top: 30px;

  .wrap {
    display: flex;
    padding: 0 90px;
    box-sizing: border-box;
    justify-content: space-between;
    margin-top: 50px;

    & > div {
      width: 233px;
      height: 340px;
      border: 2px solid #ffffff;
      border-radius: 3px;
      box-sizing: border-box;
      background: transparent;
      transition: all 0.15s linear;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 0 14px;
      padding-top: 36px;

      * {
        transition: all 0.15s linear;
      }

      &:hover {
        background-color: white;

        .bottom-img-box {
          border-color: #42aab2;
        }

        .name {
          color: #525252;
        }

        .hr {
          background: #42aab2;
        }

        .desc {
          color: #919191;
        }
      }

      .bottom-img-box {
        width: 64px;
        height: 64px;
        border: 2px solid #ffffff;
        border-radius: 50%;
        background-size: 30px 30px;
        background-position: center center;
        background-repeat: no-repeat;
        margin-bottom: 31px;
      }

      .name {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 30px;
      }

      .hr {
        width: 30px;
        height: 5px;
        background: white;
        margin: 22px 0;
      }

      .desc {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 30px;
      }
    }
  }
}

.loop(@i) when (@i =< 4) {
  .bottom-box:nth-child(@{i}) {
    .bottom-img-box {
      background-image: url("../assets/imgs/home-bottom-icon@{i}.png");
    }

    &:hover {
      .bottom-img-box {
        background-image: url("../assets/imgs/home-bottom-icon@{i}-check.png") !important;
      }
    }
  }

  .loop(@i+1);
}

.loop(1);
@media (max-width: 760px) {
  .banner {
    height: 3rem;
    object-fit: cover;
    vertical-align: middle;
  }

  .pub-img-title {
    text-align: center;
    font-size: 0;

    img {
      // width: 2.7rem;
      width: auto;
      height: 0.45rem;
      object-fit: cover;
      margin-right: 0;
    }
  }

  .wrap {
    width: 90%;
  }

  .hack {
    margin: 0.2rem auto;
    padding: 0.34rem 0.2rem;

    & > div {
      img {
        width: 0.37rem;
        margin-right: 0.09rem;
      }

      p {
        font-size: 0.1rem;

        span {
          font-size: 0.18rem;
        }
      }
    }

    .divider {
      height: 0.37rem;
    }
  }

  .second {
    margin-top: 0.3rem;
    display: block;
    margin-bottom: 0.42rem;

    .second-box {
      flex-direction: column !important;
      align-items: center;
      justify-content: center;

      div {
        width: 100%;

        p:first-child {
          font-size: 0.32rem;
          font-family: PingFang SC;
          font-weight: bold;
          color: #42aab2;
          margin-bottom: 0.2rem;
        }

        p:last-child {
          font-size: 0.24rem;
          font-family: PingFang SC;
          font-weight: 400;
          color: #666565;
          line-height: 0.35rem;
          white-space: pre-wrap;
        }
      }

      img {
        width: 100%;
        margin-right: 0;
      }
    }

    & > img {
      width: 100%;
      margin-right: 0;
      margin-top: 0.3rem;
    }

    div {
      width: 100%;

      p:last-child {
        font-size: 0.2rem;
        line-height: 0.36rem;
      }
    }
  }

  .third {
    & > div {
      & > div {
        width: 2.1rem;
        height: 1.38rem;
        margin-bottom: 0.3rem;

        .mask {
          span {
            font-size: 0.16rem;
          }

          span::after {
            width: 0.32rem;
            height: 0.03rem;
          }
        }
      }
    }
  }

  .bottom {
    background: unset;
    height: unset;
    padding-top: 0;
    width: 100%;
    overflow: hidden;

    .wrap {
      padding: 0;
      margin-top: 0.3rem;

      .bottom-box {
        width: 25%;
        border: 1px solid #f0f0f0;
      }

      & > div {
        justify-content: unset;
        padding-top: 0.3rem;
        height: unset;
        padding-bottom: 0.3rem;

        .bottom-img-box {
          height: 0.68rem;
          border-color: transparent !important;
          margin-bottom: 0.2rem;
        }

        .hr {
          background: #b5b5b5;
          margin: 0.2rem 0;
          height: 2px;
        }

        .name {
          font-size: 0.22rem;
          color: #b5b5b5;
          line-height: 0.22rem;
        }

        .desc {
          font-size: 0.2rem;
          color: #b5b5b5;
          line-height: 0.3rem;
        }

        &:hover {
          background: #42aab2;

          .hr {
            background: white;
          }

          .name,
          .desc {
            color: white;
          }
        }
      }
    }
  }

  .loop(@i) when (@i =< 4) {
    .bottom-box:nth-child(@{i}) {
      .bottom-img-box {
        background-image: url("../assets/mobile-imgs/home-bottom-icon@{i}.png");
      }

      &:hover {
        .bottom-img-box {
          background-image: url("../assets/mobile-imgs/home-bottom-icon@{i}-check.png") !important;
        }
      }
    }

    .loop(@i+1);
  }

  .loop(1);
}

.description {
  margin-top: 100px;
  margin-bottom: 20px;

  &-logo {
    display: flex;
    align-items: center;
    justify-content: center;

    div {
      width: calc(50% - 90px);
      height: 1px;
      background: #42aab2;
    }

    img {
      width: 70px;
      margin: 0 40px;
    }
  }

  &-content {
    color: #42aab2;
    font-size: 25px;
    text-align: center;

    p {
      margin: 20px 0;

      span {
        color: #e6a23c;
      }
    }
  }
}

//.what-to-do {
//  .title-img {
//    margin: 70px auto;
//    display: block;
//  }
//}
//
.pub-img-title {
  text-align: center;
}

.customer {
  position: fixed;
  z-index: 999;
  bottom: 5%;
  right: 2%;
  width: 500px;
  height: 550px;
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.3);
  animation: grow 1s forwards;
}

@keyframes grow {
  from {
    width: 0px;
    height: 0px;
  }

  to {
    width: 500px;
    height: 550px;
  }
}

.right-list-title {
  display: block;
  padding-bottom: 10px;
  width: 100%;
  border-bottom: 1px solid #e7e7e7;
}

::v-deep .scrollbar {
  height: 352px;
}

.chat-list {
  display: flex;
  overflow-y: auto;
  flex-direction: column;
  height: 100%;
}

.chat-list-left {
  padding: 20px;
  display: flex;
  flex-direction: row;
}

.chat-list-right {
  padding: 10px;
  display: flex;
  flex-direction: row-reverse;
}

.chat {
  position: relative;
  background: rgb(247, 247, 247);
  height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.list-img {
  width: 44px;
  height: 40px;
  margin-right: 10px;
  border-radius: 5px;
}

.left-msg {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
  background-color: #ffffff;
  border-radius: 6px;
  max-width: 200px;
  padding: 5px;
  font-size: 12px;
  word-wrap: break-word;
}

.right-msg {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-right: 7px;
  background-color: #95ec69;
  font-size: 12px;
  border-radius: 6px;
  max-width: 200px;
  padding: 5px;
  word-wrap: break-word;
}

.chat-boom {
  display: flex;
  z-index: 999;
  justify-content: space-between;
  align-items: flex-end;
}

.button {
  position: absolute;
  z-index: 999;
  background-color: #86bfcd;
  color: #fff;
  bottom: 5px;
  right: 5px;
}

.consultation {
  width: 70px;
  height: 140px;
  position: fixed;
  background-color: #fff;
  bottom: 15%;
  font-size: 12px;
  right: 2%;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  box-shadow: 0 0 3px 1px rgba(160, 158, 158, 0.3);
}

.consul {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
}

.info-title {
  font-size: 16px;
  font-family: "黑体";
  text-align: center;
  padding-top: 10px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
  background-color: #86bfcd;
  color: #fff;
}

.closeDialog {
  position: absolute;
  font-size: 20px;
  color: #fff;
  right: 10px;
  top: 5px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
</style>
